import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { withViewport } from '../../util/contextHelpers';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { fetchCategoriesSuggestions } from '../../ducks/categoriesSuggestions.duck';
import config from '../../config';
import {
  Page,
  SectionHero,
  SectionReviews,
  SectionHowItWorks,
  SectionTop,
  SectionLocations,
  SectionFeatures,
  SectionOurPartners,
  SectionPartners,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  SectionActiveProgram, SectionThreeSteps,
} from '../../components';
import { TopbarContainer } from '../../containers';

import SectionPopularCategories from './SectionPopularCategories';
import SectionCategories from './SectionCategories';
import PromoTiles from './PromoTiles';

import facebookImage from '../../assets/bg.jpg';
import twitterImage from '../../assets/bg.jpg';
import css from './LandingPage.css';

export const LandingPageComponent = props => {
  const { history, intl, location, scrollingDisabled, viewport, categoriesSuggestions, fetchSuggestions } = props;
  const myRef = useRef();

  const handleScroll = () => {
    if (myRef.current) {
      myRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      })
    }
  }

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  useEffect(() => {
    fetchSuggestions();
  }, []);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar rootClassName={css.landingPageTopbar}>
          <TopbarContainer currentPage={'/'} />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            {/* <div className={css.videoOverlay} /> */}
            {/* <div className={css.overlay} />
              <div className={css.overlayBottom} /> */}
            <SectionHero
              className={css.hero}
              history={history}
              location={location}
              onScroll={handleScroll}
              intl={intl}
              categoriesSuggestions={categoriesSuggestions}
              viewport={viewport}
            />
          </div>
          <ul className={css.sections}>
              <li>
                <SectionCategories
                  intl={intl}
                />
              </li>
            <li>
              {process.env.REACT_APP_COUNTRY_ID === 'pl' ? (
                <PromoTiles />
              ) : (
                <SectionPopularCategories intl={intl} />
              )}
            </li>
            {(config.locale === 'pl' || config.locale === 'hu' || config.locale === 'cz' || config.locale === 'sk') && (
              <li key="sectionActiveProgram">
                <SectionActiveProgram />
              </li>
            )}
            <SectionThreeSteps intl={intl} />
            {/* <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionOurPartners screenWidth={viewport.width}/>
              </div>
            </li> */}
            {/* <li className={cx(css.section, css.sectionWithBackground)}>
              <div className={css.sectionContentFirstChild}>
                <SectionLocations />
              </div>
            </li> */}
            {/* <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionFeatures />
              </div>
            </li> */}
            {/* <li className={cx(css.section, css.sectionWithBackground)}>
              <div className={css.sectionContent}>
                <SectionTop />
              </div>
            </li> */}
            {/* <li className={cx(css.section, css.sectionWithBackground, css.blueBack)}>
              <div className={css.sectionContent}>
                <SectionPartners />
              </div>
            </li> */}
          </ul>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { categoriesSuggestions } = state.categoriesSuggestions;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    categoriesSuggestions,
  };
};

const mapDispatchToProps = dispatch => ({
  fetchSuggestions: () => dispatch(fetchCategoriesSuggestions()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  withViewport,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LandingPageComponent);

export default LandingPage;
